import { render, staticRenderFns } from "./ApeironProductDetail.vue?vue&type=template&id=59b2e180"
import script from "./ApeironProductDetail.vue?vue&type=script&lang=js"
export * from "./ApeironProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports